// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"712":"ee88c5fd","808":"f66318ec"}[chunkId] + ".chunk.css";
};